export default abstract class BaseFilter {
	static shouldBeInitialized(): boolean {
		return false;
	};

	shouldShow(gridItem: HTMLElement): boolean {
		return true;
	};
}
